// import headerBg from '@/assets/images/active/travel/hacker/header/header_bg.png';
// import headerBg2 from '@/assets/images/active/travel/hacker/header/header_bg2.png';
// import officeBtn from '@/assets/images/active/travel/hacker/header/btn_05.png';
// import loginBtn from '@/assets/images/active/travel/hacker/header/btn_06.png';
// import accountBtn from '@/assets/images/active/travel/hacker/header/btn_07.png';
// import activeBtn from '@/assets/images/active/travel/hacker/header/btn_09.png';
// import logoutBtn from '@/assets/images/active/travel/hacker/header/btn_10.png';

export const headerConfig = {
  not_logged_in: {
    background_image: 'https://download4.qcplay.com/h5-images/active/travel/hacker/header/header_bg.png',
    style: ''
  },
  logged_in: {
    background_image: 'https://download4.qcplay.com/h5-images/active/travel/hacker/header/header_bg2.png',
    main_title_color: '#fff',
    sub_title_color: '#fff',
    tips_color: '#fff',
    game_name: '时光旅行社'
  },
  operation_btn: {
    office_website: {
      width: '',
      height: '',
      background_image: '',
      img: 'https://download4.qcplay.com/h5-images/active/travel/hacker/header/btn_05.png',
      style: 'top: 0.24rem',
      link: 'https://sglxs.qingcitimes.com/'
    },
    login: {
      width: '',
      height: '',
      background_image: '',
      img: 'https://download4.qcplay.com/h5-images/active/travel/hacker/header/btn_06.png',
      style: 'top: 0.24rem'
    },
    change_account: {
      width: '',
      height: '',
      background_image: '',
      img: 'https://download4.qcplay.com/h5-images/active/travel/hacker/header/btn_07.png',
      style: 'top: 0.24rem'
    },
    join_active: {
      width: '',
      height: '',
      background_image: '',
      img: 'https://download4.qcplay.com/h5-images/active/travel/hacker/header/btn_09.png',
      style: 'top: 0.24rem',
      link: ''
    },
    logout: {
      width: '',
      height: '',
      background_image: '',
      img: 'https://download4.qcplay.com/h5-images/active/travel/hacker/header/btn_10.png',
      style: 'top: 0.24rem'
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/travel/hacker/headerConfig.js